import React from "react";
import "./Footer.css";
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-col brand-col">
          <div className="footer-brand">ProConnet</div>
          <div className="footer-contact">
            <div className="footer-phone">+216 96 397 510 </div>
            <div className="footer-email">info@proconnet.tn</div>
          </div>
          <div className="footer-socials">
            <button aria-label="LinkedIn" className="footer-social"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 8a6 6 0 0 1 6 6v6"/><line x1="2" y1="12" x2="22" y2="12"/></svg></button>
            <button aria-label="Facebook" className="footer-social"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 12h2"/></svg></button>
            <button aria-label="Twitter" className="footer-social"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M8 12c1.5 2 4.5 2 6 0"/></svg></button>
          </div>
        </div>
        <div className="footer-col links-col">
          <div className="footer-links-title">{t('footer_links_title')}</div>
          <ul className="footer-links-list">
            <li><a href="#support">{t('services')}</a></li>
            <li><a href="#about">{t('about')}</a></li>
            <li><a href="#hero">{t('home')}</a></li>
            <li><a href="#contact">{t('contact')}</a></li>
          </ul>
        </div>
        <div className="footer-col subscribe-col">
          <div className="footer-links-title">{t('footer_subscribe_title')}</div>
          <form className="footer-subscribe-form">
            <input type="email" placeholder={t('footer_subscribe_placeholder')} aria-label="Subscribe Email" />
            <button type="submit" aria-label="Subscribe">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </button>
          </form>
        </div>
      </div>
      <div className="footer-bottom-row">
        <div className="footer-copyright">
          © 2025 ProConnet. {t('footer_rights')}
        </div>
      </div>
    </footer>
  );
}
